import React, { useState, useEffect } from 'react';
import {
  formatDateMonth,
  formatPrice,
  LoadingGrid,
} from '../../../../../_mexablock/helpers';
import Select, { MultiValue } from 'react-select';
import { statusSelectStyles } from '../models/statusSelectStyles';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import 'flatpickr/dist/flatpickr.min.css';
import { MenuComponent } from '../../../../../_mexablock/assets/ts/components';
import { Filter } from './Filter';
import {
  downloadPackageReportPDF,
  getAllPackageMovements,
  downloadPackageReportZip,
} from '../../../../service/inventario/entrada&salidas';
import { DevolverAsignarModal } from '../_modals/DevolverAsignarModal';
import { DetalleModal } from '../_modals/DetalleModal';
import { DevolverModal } from '../_modals/DevolverModal';

type OptionType = {
  value: number;
  label: string;
};

const View: React.FC = () => {
  const [reloadGrid, setReloadGrid] = useState<number>();
  const [loadingView, setloadingView] = useState(true);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [visivilityModalComments, setVisivilityModalComments] =
    useState<boolean>(false);
  const [visivilityModalDevolucion, setVisivilityModalDevolucion] =
    useState<boolean>(false);

  const [devAsigModal, setDevAsigModal] = useState();
  const [commetsModal, setcommetsModal] = useState({});
  const [detailModal, setDetailModal] = useState({});
  const [dataSends, setDataSends] = useState<any[]>([]);
  const [dateState, setDateState] = useState<string[]>([]);
  const [tipoMovimiento, setTipoMovimiento] = useState<boolean | undefined>();
  const [statusFilter, setStatusFilter] = useState<number>(0);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');
  type YearOption = { value: number; label: string };
  const [selectedOptionStatus, setSelectedOptionStatus] = useState<
    MultiValue<YearOption>
  >([]);
  const [selectedOptionMov, setSelectedOptionMov] = useState<YearOption | null>(
    null
  );
  const [tipoStatus, setTipoStatus] = useState<number[]>([]);
  const [initFilterValues, setInitFilterValues] = useState({
    type_stock_id: 0,
    status_id: 0,
    movements_id: 0,
    user_id: '',
    init_date: '',
    end_date: '',
    filter: 0,
  });

  const fetchPost = async () => {
    try {
      const filters = {
        start_date: dateState[0],
        end_date: dateState[1],
        type_stock_id: statusFilter,
        is_output: tipoMovimiento,
        status_id: tipoStatus,
        search: searchFilter,
      };
      const sends = await getAllPackageMovements(filters);
      if (sends) {
        setDataSends(sends);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setloadingView(false);
    }
  };
  useEffect(() => {
    MenuComponent.reinitialization();
  }, [dataSends]);

  useEffect(() => {
    fetchPost();
  }, [
    dateState,
    statusFilter,
    searchFilter,
    tipoMovimiento,
    tipoStatus,
    reloadGrid,
  ]);

  const infoStatusComments = (statusinfo: any) => {
    setDevAsigModal(statusinfo);
    setVisivilityModal(true);
  };

  const infoDetails = (comment: any) => {
    setcommetsModal(comment);
    setVisivilityModalComments(true);
  };
  const infoDevolucion = (comment: any) => {
    setDetailModal(comment);
    setVisivilityModalDevolucion(true);
  };

  const infoComprobante = async (idRegister: any) => {
    if (idRegister?.id) {
      try {
        await downloadPackageReportPDF(idRegister.id);
      } catch (err) {
        console.error('Error al descargar el comprobante:', err);
      }
    }
  };

  const infoComprobanteZip = async (idRegister: any) => {
    if (idRegister?.id) {
      try {
        await downloadPackageReportZip(idRegister.id);
      } catch (err) {
        console.error('Error al descargar el comprobante:', err);
      }
    }
  };

  const columns: any = [
    {
      id: 'mov',
      name: <div className="fw-bolder text-muted me-5">Mov</div>,
      selector: (row: any) => (row.is_output ? 'Salida' : 'Entrada'),
      sortable: true,
      width: '100px',
    },
    {
      id: 'created_at',
      name: <div className="fw-bolder text-muted me-5">Fecha Ingreso</div>,
      selector: (row: any) => row.package.createdAt,
      cell: (row: any) =>
        row.package ? formatDateMonth(row.package.createdAt) : 'Sin fecha',
      sortable: true,
      width: '151px',
    },

    // {
    //   id: 'type_stock_id',
    //   name: <div className="fw-bolder text-muted me-5">Tipo</div>,
    //   selector: (row: any) => row.package?.type_stock_id || 0,
    //   cell: (row: any) => (row.package?.type_stock_id === 1 ? 'SIM' : 'E-SIM'),
    //   sortable: true,
    //   width: '90px',
    // },
    {
      id: 'price',
      name: <div className="fw-bolder text-muted me-5">Precio</div>,
      selector: (row: any) => Number(row.price),
      cell: (row: any) =>
        row.price
          ? `${formatPrice(Number(row.price), 'es-MX', 'MXN', 2, 2)}`
          : '',
      sortable: true,
      width: '130px',
    },
    {
      id: 'row.amount',
      name: <div className="fw-bolder text-muted me-5">Cantidad</div>,
      selector: (row: any) => (row.amount ? `${row.amount} Pzs` : ''),
      sortable: true,
      width: '120px',
    },
    {
      id: 'original_location',
      name: <div className="fw-bolder text-muted me-5">Ubic Origen</div>,
      selector: (row: any) => (row.package ? row.package.location : ''),
      sortable: true,
      width: '140px',
    },
    {
      id: 'out_date',
      name: <div className="fw-bolder text-muted me-5">Fecha Salida</div>,
      selector: (row: any) =>
        row.out_date ? formatDateMonth(row.out_date) : 'Sin salida',
      sortable: true,
      width: '145px',
    },
    {
      id: 'current_location',
      name: <div className="fw-bolder text-muted me-5">Ubic Actual</div>,
      selector: (row: any) =>
        row.is_output ? 'Fuera de almacén' : row.package.location,
      sortable: true,
      width: '180px',
    },
    {
      id: 'motive_name',
      name: <div className="fw-bolder text-muted me-5">Razón</div>,
      selector: (row: any) => (row.motive_name ? row.motive_name : 'No aplica'),
      sortable: true,
      width: '160px',
    },
    {
      id: 'first_name',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) => row.creator?.first_name,
      cell: (row: any) => {
        const c = row.creator;
        return (
          <div>
            {c
              ? `${c.first_name || ''} ${c.father_last_name || ''} ${
                  c.mother_last_name || ''
                }`.trim()
              : 'Sin asignar'}
          </div>
        );
      },
      sortable: true,
      width: '200px',
    },
    {
      id: 'status_id',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.status?.name || '',
      cell: (row: any) => statusEnvio(row.status?.id, row.status?.name),
      sortable: true,
      width: '120px',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      cell: (row: any) => dropdownRender(row),
      sortable: false,
      width: '100px',
    },
  ];

  const statusEnvio = (id: number, name: string) => {
    switch (id) {
      case 11:
        return (
          <span className="fw-normal badge badge-light-primary text-center d-inline-block">
            {name}
          </span>
        );
      case 13:
        return (
          <span className="fw-normal badge badge-light-success text-center d-inline-block">
            {name}
          </span>
        );
      case 14:
        return (
          <span className="fw-normal badge badge-light-warning text-center d-inline-block">
            {name}
          </span>
        );

      case 15:
        return (
          <span className="fw-normal badge badge-light-danger text-center d-inline-block">
            {name}
          </span>
        );
    }
  };

  const dropdownRender = (row: any) => {
    const isDisabled =
      row.status_id === 15 ||
      (row.status_id === 13 && row.stock_movements.length === 0);

    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <a
            data-kt-menu={!isDisabled ? 'true' : undefined}
            className={`btn btn-light btn-active-light-primary btn-sm ${
              isDisabled ? 'disabled' : ''
            }`}
            data-kt-menu-trigger={!isDisabled ? 'click' : undefined}
            data-kt-menu-placement="bottom-end"
            style={isDisabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </a>

          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
            data-kt-menu="true"
          >
            {row.status_id === 11 && row.package.type_stock_id === 1 ? (
              <>
                <div className="menu-item px-3">
                  <a
                    className="menu-link px-3"
                    href="#/"
                    onClick={() => {
                      infoDetails(row);
                    }}
                  >
                    Devolver
                  </a>
                </div>
                <div className="menu-item px-3">
                  <a
                    className="menu-link px-3"
                    onClick={(e) => {
                      e.preventDefault();
                      infoComprobante(row);
                    }}
                  >
                    Descargar comprobante
                  </a>
                </div>
              </>
            ) : null}

            {row.package.type_stock_id === 2 && row.status_id === 11 ? (
              <>
                <div className="menu-item px-3">
                  <a
                    className="menu-link px-3"
                    href="#/"
                    onClick={() => {
                      infoDetails(row);
                    }}
                  >
                    Devolver
                  </a>
                </div>
                <div className="menu-item px-3">
                  <a
                    className="menu-link px-3"
                    onClick={(e) => {
                      e.preventDefault();
                      infoComprobanteZip(row);
                      infoComprobante(row);
                    }}
                  >
                    Descargar comprobante
                  </a>
                </div>
              </>
            ) : null}
            {row.status_id === 14 ? (
              <div className="menu-item px-3">
                <a
                  className="menu-link px-3"
                  href="#/"
                  onClick={() => {
                    infoDevolucion(row);
                  }}
                >
                  Ver detalle
                </a>
              </div>
            ) : null}

            {row.status_id === 13 ? (
              <div className="menu-item px-3">
                <a
                  className="menu-link px-3"
                  href="#/"
                  onClick={() => {
                    infoStatusComments(row);
                  }}
                >
                  Asignar
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  };

  const handleCustomerChangeStatus = (selected: MultiValue<YearOption>) => {
    if (selected) {
      setSelectedOptionStatus(selected);
      const statusValues = selected.map((item) => item.value);
      setTipoStatus(statusValues);
    }
  };

  const handleCustomerChangeMovements = (selected: any) => {
    setSelectedOptionMov(selected);

    if (selected) {
      const tipoMovimiento = selected.value;
      if (tipoMovimiento === 13) {
        setTipoMovimiento(true); // salida
      }
      if (tipoMovimiento === 11) {
        setTipoMovimiento(false); // entrada
      }
    } else {
      setTipoMovimiento(undefined);
    }
  };

  const statusOptions: OptionType[] = [
    { value: 11, label: 'Asignado' },
    { value: 13, label: 'En almacén' },
    { value: 14, label: 'Devuelto' },
    { value: 15, label: 'Agotado' },
  ];

  const typeMovementsOptions = [
    { value: 11, label: 'Entrada' },
    { value: 13, label: 'Salida' },
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑ]*$/;
    if (regex.test(e.target.value)) {
      setInputValue(e.target.value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
    }
  };

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
    if (values) {
      setDateState([values.init_date, values.end_date]);
    }
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      type_stock_id: 0,
      status_id: 0,
      movements_id: 0,
      user_id: '',
      init_date: '',
      end_date: '',
      filter: 0,
    });
    setDateState([]);
  };

  useEffect(() => {
    const statusIdsStatus = Array.isArray(selectedOptionStatus)
      ? selectedOptionStatus.map((opt) => opt.value).join(',')
      : '';

    setInitFilterValues((prev: any) => ({
      ...prev,
      status_id: statusIdsStatus,
    }));
  }, [selectedOptionStatus]);

  useEffect(() => {
    const statusIdMov = selectedOptionMov ? selectedOptionMov.value : '';
    setInitFilterValues((prev: any) => ({
      ...prev,
      movements_id: statusIdMov,
    }));
  }, [selectedOptionMov]);

  const [selected, setSelected] = useState<OptionType[]>([]);

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="row w-100 gx-2">
                <div className="col-2">
                  <Filter
                    initFilterValues={initFilterValues}
                    onCleanFilter={handleFilterClean}
                    onSearchFilter={handleFilter}
                  />
                </div>
                <div className="col-2">
                  <Select
                    options={typeMovementsOptions}
                    placeholder={'Movimientos'}
                    onChange={handleCustomerChangeMovements}
                    value={selectedOptionMov}
                    noOptionsMessage={() => <span>No hay registros</span>}
                    menuPortalTarget={document.body}
                    styles={statusSelectStyles}
                    isClearable
                  />
                </div>
                <div className="col-2">
                  <Select
                    options={statusOptions}
                    placeholder={'Estatus'}
                    onChange={handleCustomerChangeStatus}
                    value={selectedOptionStatus}
                    isMulti
                    noOptionsMessage={() => <span>No hay registros</span>}
                    menuPortalTarget={document.body}
                    styles={statusSelectStyles}
                  />
                </div>
                <div className="col-3">
                  {/* <ul className="nav justify-content-center align-items-center w-100 d-flex">
                    {[
                      { label: 'Todo', value: 0 },
                      { label: 'SIM', value: 1 },
                      { label: 'E-SIM', value: 2 },
                    ].map(({ label, value }) => (
                      <li
                        key={value}
                        className="nav-item bg-white flex-fill text-center"
                        style={{ maxWidth: '120px' }}
                      >
                        <a
                          className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold ${
                            statusFilter === value ? 'active' : ''
                          }`}
                          onClick={() => setStatusFilter(value)}
                        >
                          {label}
                        </a>
                      </li>
                    ))}
                  </ul> */}
                </div>
                <div className="col-3">
                  <div className="d-flex align-items-center position-relative me-4">
                    <span
                      className="position-absolute ms-3"
                      style={{ zIndex: 10 }}
                    >
                      <i className="bi bi-search fs-4 text-muted"></i>
                    </span>

                    <input
                      type="text"
                      className="form-control form-control-solid ps-9"
                      placeholder="Buscar por ubicación"
                      maxLength={50}
                      onKeyDown={handleKeyDown}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={dataSends} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <DevolverAsignarModal
        data={devAsigModal}
        show={visivilityModal}
        handleRefresh={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
        }}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModal(!visivilityModal);
        }}
      ></DevolverAsignarModal>
      <DetalleModal
        data={detailModal}
        show={visivilityModalDevolucion}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModalDevolucion(!visivilityModalDevolucion);
        }}
      />
      <DevolverModal
        data={commetsModal}
        show={visivilityModalComments}
        handleRefresh={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
        }}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModalComments(!visivilityModalComments);
        }}
      />
    </>
  );
};

export { View };
